import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			x: 5,
			y: 5,
			width: 54,
			height: 54,
			rx: 4
		}), /* @__PURE__ */ _jsx("path", {
			d: "M33.093 17C39.863 17 45 20.955 45 27.318c0 6.227-5.136 10.552-11.907 10.552H29l.028 8.127a1 1 0 0 1-1 1.003H22a1 1 0 0 1-1-1V18a1 1 0 0 1 1-1h11.093zm.047 6.818h-4.109v7.046h4.11c2.24 0 3.688-1.41 3.688-3.546 0-2.09-1.448-3.5-3.689-3.5z",
			fill: "currentColor"
		})]
	})
});
export default SvgParkinginline;
